function setupButtonEvent() {
    // ポップアップ要素
    let modal = document.getElementById("modal");

    // 背景をクリックして閉じる
    modal.addEventListener("click", function (event) {
        if (event.target === modal) {
            modal.style.display = "none";
        }
        return 0;
    });

    // URL
    let urlPath = "users/change/available/"
    let url = window.location.protocol + "//" + window.location.host;
    url = url + "/" + urlPath;

    let urlQueryString = window.location.search;
    let resultQueryStringArray = [];
    if (!(urlQueryString === "")) {
        urlQueryString = urlQueryString.slice(1);
        let queryStringArray = urlQueryString.split("&");
        queryStringArray.forEach(function (item) {
            resultQueryStringArray.push(item.split("="));
        })
    }

    // はいを選択したとき
    let submitButton = document.getElementById("modalSubmit");
    submitButton.addEventListener('click', function (event) {
        // フォームを送信する
        let form = document.createElement("form");
        form.action = url + event.target.dataset.submitId;
        form.method = 'POST';

        // CSRFトークンをhiddenで付与
        const token = document.querySelector('meta[name="csrf-token"]')?.content;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'authenticity_token';
        input.value = token;
        form.appendChild(input);

        if (resultQueryStringArray.length > 0) {
            form.addEventListener("formdata", function (event) {
                resultQueryStringArray.forEach(function (item) {
                    event.formData.append(item[0], item[1]);
                });
            });
        }

        document.body.append(form);
        form.submit();
        return 0;
    });

    // いいえを選択したとき
    let closeButton = document.getElementById("modalClose");
    closeButton.addEventListener('click', function () {
        modal.style.display = "none";
        return 0;
    });

    // ボタンの要素
    let elemChangeButtonArray = Array.prototype.slice.call(document.getElementsByClassName("changeButtons"));

    elemChangeButtonArray.forEach(function (element) {
        element.addEventListener("click", function (event) {
            modal.style.display = "block";
            submitButton.dataset.submitId = event.target.dataset.id;
            return 0;
        });
    });

}

function displaySelectBox() {
    let queryStrings = new URLSearchParams(window.location.search);
    let yearFilter = queryStrings.get("year_filter");

    if (yearFilter) {
        let elemYearSelect = document.getElementById("yearSelect");
        elemYearSelect.value = yearFilter;
    }
    return 0;
}

export function changeModal() {
    setupButtonEvent();
    displaySelectBox();
}
